import React from 'react';
import Styles from './assets/Styles.scss';

function EbaFlowContainer(props: React.PropsWithChildren<{ url: string }>) {
	return (
		<iframe
			className={Styles.ebaFlowFrame}
			src={props.url}
			frameBorder="0"
		/>
	);
}

export default EbaFlowContainer;
